var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 184,
    viewBox: "0 0 260 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.771 102.173C148.77 97.4831 171.566 86.3033 176.583 67.5782L107.001 48.9336C101.984 67.6587 116.136 88.7387 124.182 98.7995C112.184 103.489 89.3872 114.669 84.3698 133.394L153.953 152.039C158.97 133.314 144.818 112.234 136.771 102.173Z",
    fill: "#F6FCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.346 143.716C152.346 139.582 150.095 135.79 146.614 133.56C142.413 130.866 136.471 127.789 130.456 127.097C130.388 127.089 130.309 127.068 130.224 127.039C129.26 126.709 128.715 125.681 128.866 124.673L132.169 102.703C132.326 101.658 133.029 100.775 134.013 100.388L135.8 99.6839C142.341 97.137 151.435 92.9261 159.204 86.9194C160.027 86.2832 159.675 84.9696 158.642 84.8504C152.569 84.1513 140.331 81.9829 131.363 75.4167C123.536 69.6799 118.118 71.0439 115.195 72.8198C113.556 73.8148 113 75.9192 113.819 77.6524C117.493 85.4242 122.413 92.3241 126.263 97.129L127.425 98.5896C128.102 99.44 128.258 100.592 127.833 101.592L119.395 121.43C118.878 122.644 117.405 123.119 116.276 122.436L115.331 121.863C112.264 120.005 108.917 118.656 105.419 117.868C101.079 116.89 96.4883 118.32 93.6286 121.728C91.1344 124.7 89.0952 127.973 87.7543 131.547L151.94 148.746C152.217 147.081 152.347 145.402 152.346 143.716Z",
    fill: "#A8C5E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.252 60.6886L111.599 43.633C108.233 42.7311 104.774 44.7284 103.872 48.0944L179.714 68.4162C180.616 65.0502 178.618 61.5906 175.252 60.6886Z",
    fill: "#A8C5E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7012 140.282L149.354 157.338C152.72 158.24 156.18 156.243 157.082 152.877L81.2393 132.555C80.3373 135.921 82.3352 139.38 85.7012 140.282Z",
    fill: "#A8C5E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M134.032 95.1449C122.021 99.785 99.1991 110.846 94.2123 129.457L86.7013 127.445C91.6881 108.834 114.51 97.7724 126.527 93.1338C118.439 83.1083 104.206 62.1177 109.192 43.5068L116.703 45.5194C111.717 64.1303 125.95 85.1209 134.032 95.1449Z",
    fill: "#A8C2DD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.ebf77ca2d3b864fbc14093c81a2aee24.svg";
export { ForwardRef as ReactComponent };